/* eslint-disable */
import React, { Component, useEffect } from "react";
import Collapsible from "react-collapsible";
import Loader from "react-loader";
import documents from "../images/documents.png";
import Modal from "react-modal";
import { FiAlignLeft, FiChevronLeft, FiFileText, FiLink2, FiPrinter } from "react-icons/fi";
import getFileIcon from "../../utils/getFileIcon";
import EducationWorkProgramsBooksTable from "../educationWorkPrograms/BooksTable/EducationWorkProgramsBooksTable";
import { getAllHeaders } from "../../utils/getAllHeaders";
import { applyPageWidth } from "../shared/usePageWidth";
import stylesNew from './styles.module.scss'


export default class Discipline extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oid: null,
      files: [],
      title: "",
      tlid: null,
      isOpen: false,
      isOpenFiles: false,
      tabSemesters: true,
      isActive: []
    };
    this.renderTitle = this.renderTitle.bind(this);

    this.renderSemester = this.renderSemester.bind(this);
    this.renderSemesterFiles = this.renderSemesterFiles.bind(this);
    this.renderFile = this.renderFile.bind(this);
  }

  componentDidMount() {
    // карточка объявляет ширину колонки контента сама — как и перечень режима
    this.releasePageWidth = applyPageWidth('pageWide');
    this.props.didMount(this.props.match.params);
    this.props.getCourse(this.props.match.params.cid);
  }

  componentWillUnmount() {
    this.releasePageWidth && this.releasePageWidth();
  }

  fun = (id) => {
    const active = [...this.state.isActive];
    if (active.includes(id)) {
      const filterActive = active.filter(el => el != id)
      this.setState({ isActive: filterActive })
    } else {
      active.push(id);
      this.setState({ isActive: active })
    }
  }


  renderTitle(raw, headers) {
    const isOpened = this.state.isActive.includes(raw.oid);
    const lessons = (raw?.lessons || []).filter(l => l && (l.lesson || l.title || l.typename));
    const isExpandable = lessons.length > 0;

    const renderHours = (source) => headers.map((alias, idx) => {
      const hoursArr = Array.isArray(source?.hours) ? source.hours : [];
      const el = hoursArr.find((element) => element.alias === alias);
      let value = el && el.hours ? Math.round(el.hours) : null;

      if (value === null && typeof source?.hours === 'number' && idx === 0) {
        value = Math.round(source.hours);
      }
      return <td key={`${source?.lesson_id || source?.oid || alias}-${alias}`}>{value}</td>;
    });

    const parentRow = (
      <tr key={`theme-${raw.oid}`} className="tableSemestr__theme">
        <td>{raw.title_index}</td>
        <td className="row-title">
          {isExpandable ? (
            <span className="tableSemestr__toggle" onClick={() => this.fun(raw.oid)}>
              {isOpened ? '-' : '+'}
            </span>
          ) : (
            <span className="tableSemestr__toggle tableSemestr__toggle--disabled" />
          )}
          <span className="tableSemestr__title">{raw.title}</span>
        </td>
        {renderHours(raw)}
        <td>{raw.interm_test}</td>
        <td>{raw.test}</td>
        <td>{raw.independent_work}</td>
        <td className="td-center"></td>
      </tr>
    );

    if (!isOpened) {
      return parentRow;
    }

    const lessonRows = lessons.map((lesson, i) => (
      <tr
        key={`lesson-${lesson.lesson_id || `${raw.oid}-${i}`}`}
        className="tableSemestr__lesson"
      >
        <td>{raw.title_index ? `${raw.title_index}.${i + 1}` : i + 1}</td>
        <td className="row-title tableSemestr__lessonTitle">
          <span className="tableSemestr__branch" />
          <span>{lesson.lesson || lesson.title || lesson.typename || raw.title}</span>
        </td>
        {renderHours(lesson)}
        <td>{lesson.interm_test ?? null}</td>
        <td>{lesson.test ?? null}</td>
        <td>{lesson.independent_work ?? null}</td>
        <td className="td-center">
          {lesson.files?.length ? (
            <div
              onClick={() => this.setState({
                isOpenFiles: true,
                fileList: lesson,
                oid: raw.oid,
                tlid: raw.tlid,
                title: lesson.lesson,
              })}
              className="folder_dis"
              title="Показать файлы занятия"
            />
          ) : null}
        </td>
      </tr>
    ));

    return [parentRow, ...lessonRows];
  }

  renderSemester = (raw, i) => {
    let examination = "";
    const headers = getAllHeaders(raw);
    if (this.props.course) {
      const data = this.props.course[0] || {};
      const rawResolved = parseInt(raw.semester.split("-")[0]);

      const fin = {
        fin_exam: data.fin_exam,
        fin_test: data.fin_test,
        fin_test_with_grade: data.fin_test_with_grade,
        fin_test_work: data.fin_test_work,
      };

      if (fin.fin_exam && fin.fin_exam.length > 0) {
        examination = fin.fin_exam.includes(rawResolved)
          ? "Экзамен"
          : examination;
      }

      if (fin.fin_test && fin.fin_test.length > 0) {
        examination = fin.fin_test.includes(rawResolved)
          ? "Зачёт"
          : examination;
      }

      if (fin.fin_test_with_grade && fin.fin_test_with_grade.length > 0) {
        examination = fin.fin_test_with_grade.includes(rawResolved)
          ? "Зачёт с оценкой"
          : examination;
      }

      if (fin.fin_test_work && fin.fin_test_work.length > 0) {
        examination = fin.fin_test_work.includes(rawResolved)
          ? "Защита курсовой работы"
          : examination;
      }
    }


    return (
      <Collapsible
        key={i}
        classParentString="cemests"
        trigger={raw.semester}
        triggerSibling={() => (
          <img
            onClick={() =>
              this.setState({
                oid: 0,
                files: {
                  semesterFiles: this.props.disciplineDetails[i].semesterFiles,
                  examFiles: this.props.disciplineDetails[i].examFiles,
                  testFiles: this.props.disciplineDetails[i].testFiles,
                  gradedTestFiles: this.props.disciplineDetails[i].gradedTestFiles,
                },
                title: raw.semester,
                tlid: raw.semesterId,
                isOpen: true,
              })
            }
            src={documents}
            alt=""
            className="folder_icon"
          />
        )}
      >
        <table className="tableSemestr">
          <tr>
            <th className="table-title">
              Код темы
            </th>
            <th className="table-title thw300">
              Наименование
            </th>
            {headers.map((item) => (
              <th className="table-title">{item}</th>
            ))}
            <th className="table-title">Зач.в теч. семестра</th>
            <th className="table-title">СР</th>
            <th className="table-title">Сессия, зе</th>
            <th className="table-title">Файлы</th>
          </tr>

          {raw.list.map((it) => this.renderTitle(it, headers))}
          <tr>
            <th colSpan={headers.length + 6} className="table-title pos-rel exam">
              {examination}
            </th>
          </tr>
        </table>
      </Collapsible>
    );
  };

  renderSemesterFiles() {
    const {
      semesterFiles,
      examFiles,
      testFiles,
      gradedTestFiles,
    } = this.state.files;
    return (
      <div>
        {semesterFiles && (
          <div>
            <h4>{this.state.title}</h4>
            {semesterFiles.map((file, i) => this.renderFile(file, i))}
          </div>
        )}
        {testFiles && (
          <div>
            <h4>Зачет</h4>
            {testFiles.map((file, i) => this.renderFile(file, i, "_1"))}
          </div>
        )}
        {gradedTestFiles && (
          <div>
            <h4>Зачет с оценкой</h4>
            {gradedTestFiles.map((file, i) => this.renderFile(file, i, "_2"))}
          </div>
        )}
        {examFiles && (
          <div>
            <h4>Экзамен</h4>
            {examFiles.map((file, i) => this.renderFile(file, i, "_3"))}
          </div>
        )}
      </div>
    );
  }

  renderFile(file, i, specialOid) {
    const { eyid } = this.props.match.params;
    const { idCurr } = this.props;
    const { tlid } = this.state;
    const oid = specialOid ? specialOid : this.state.oid;
    return (
      <div key={i}>
        <img src={getFileIcon(file.type)} alt="icon" />
        <p
          onClick={() => this.props.getFile(idCurr, eyid, tlid, oid, file.file)}
          className="umk-right-p"
        >
          {file.file}
        </p>
      </div>
    );
  }

  renderLessonFile(file, i) {
    return (
      <div key={i}>

        {
          file.url ?
            <a href={file.url} target="_blank">
              <img src={getFileIcon(file.file)} alt="icon" />
              <p
                className="umk-right-p fileLink"
              >
                {file.file}
              </p>
            </a>
            :
            <>
              <img src={getFileIcon(file.file)} alt="icon" />
              <p
                onClick={() => this.props.getLessonsFile(this.state.fileList.lesson_id, file.file)}
                className="umk-right-p"
              >
                {file.file}
              </p>
            </>
        }
      </div>
    );
  }

  // handleChangeTab = () => {
  //   const params = this.props.history.location.state

  //   if (params && params.id) {
  //     this.props.history.push({
  //       pathname: `/disprograms/${params.id}`,
  //       state: params
  //     })
  //   } else {
  //     this.setState({ tabSemesters: !this.state.tabSemesters })
  //   }
  // }

  handleBack = () => {
    const { isTeacher, history, location } = this.props
    const { state } = location
    // const pathname = isTeacher ? (state?.curriculumId === 0 ? '/disprograms' : '/support_study_dis') : '/umk'
    const pathname = isTeacher ? '/disprograms' : '/umk'
    history.push({ pathname, state })
  }

  toggleModal = (isOpen) => this.setState({ isOpen });
  toggleModalFiles = (isOpenFiles) => this.setState({ isOpenFiles });

  render() {
    const {
      disciplineDetails,
      course,
      isLoading,
      books,
      ccId,
      booksInfo,
      moreInfo,
      getMoreInfo,
      getFile,
      getSignedCopyFile
    } = this.props;

    const { idcurriculum, cid } = this.props.match.params;

    const educationYear =
      disciplineDetails.length > 0
        ? disciplineDetails[0].list[0].educationyear
        : null;

    // Сведения о программе приходят строкой перечня режима «Рабочие программы
    // дисциплин (модулей)». При входе из УМК их нет — берём то, что есть в карточке
    const program = this.props.location?.state?.program || {};
    const planName = disciplineDetails[0]?.list[0]?.curriculum_name;
    const metaCourseName = course && course[0]?.meta_course_name;

    const fields = [
      ['Воен.специальн.', program.spec],
      ['Дисциплина', program.discipline || metaCourseName],
      ['Название', program.name],
      ['Статус', program.status],
      ['Учебный план', program.curriculumName || planName],
    ];

    const cardTitle = program.name || metaCourseName || 'Рабочая программа дисциплины';

    return (
      <div className={stylesNew.page}>
        <Loader color="#7b2b2a" loaded={!isLoading}>
          <div className={stylesNew.cardHead}>
            <button className={stylesNew.backBtn} onClick={() => this.handleBack()}>
              <FiChevronLeft size={16} />
              Назад к списку
            </button>
          </div>

          <div className={stylesNew.yearLine}>{educationYear && educationYear.toUpperCase()}</div>
          <h1 className={`${stylesNew.title} ${stylesNew.titleRow}`}>{cardTitle}</h1>

          <div className={stylesNew.fieldsGrid}>
            {fields.map(([label, value]) => (
              <div key={label}>
                <label className={stylesNew.fieldLabel}>{label}</label>
                <div className={stylesNew.fieldValue}>
                  {value || <span className={stylesNew.dash}>—</span>}
                </div>
              </div>
            ))}
          </div>

          <div className={stylesNew.actRow}>
            <button
              className={`${stylesNew.actBtn} ${stylesNew.actPrimary}`}
              onClick={() => getSignedCopyFile(ccId)}
            >
              <FiFileText size={17} />
              Просмотр программы
            </button>
            <button
              className={`${stylesNew.actBtn} ${stylesNew.actSecondary}`}
              onClick={() => window.print()}
            >
              <FiPrinter size={17} />
              Печать
            </button>
          </div>

          {this.state.tabSemesters ? (
            <div className={"semesters"}>
              {disciplineDetails.map(this.renderSemester)}
              <MoreInfo
                data={moreInfo || {}}
                getData={() => getMoreInfo(idcurriculum, cid)}
                getFile={getFile}
              />
            </div>
          ) : books && books.length > 0 ? (
            <EducationWorkProgramsBooksTable
              data={books}
              onDelete={() => { }}
              courseId={this.props.idCurr}
              getBooksInfo={this.props.getBooksInfo}
              booksInfo={booksInfo}
            />
          ) : (
            <p>
              Библиографические записи по данной дисциплине отсутствуют
            </p>
          )}
        </Loader>


        <Modal
          isOpen={this.state.isOpen}
          onRequestClose={() => this.toggleModal(!this.state.isOpen)}
          contentLabel="Modal"
          className="disciplineModal"
        >
          <div className="umk-right">
            <div className="umk-right-rectangle">
              {this.state.oid === 0 ? (
                this.renderSemesterFiles()
              ) : (
                <div>
                  <h4 style={{ textAlign: "center", padding: "0 0.5rem" }}>{this.state.title}</h4>
                  {this.state.files.map((file, i) => this.renderFile(file, i))}
                </div>
              )}
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.isOpenFiles}
          onRequestClose={() => this.toggleModalFiles(!this.state.isOpenFiles)}
          contentLabel="Modal"
          className="disciplineModal"
        >
          <div className="umk-right">
            <div className="umk-right-rectangle">
              <div>
                <h4 style={{ textAlign: "center" }}>"{`${this.state?.fileList?.lesson}`}"</h4>
                {this.state.fileList?.files.map((el, i) => this.renderLessonFile(el, i))}
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}


const MoreInfo = ({ data, getData, getFile }) => {

  useEffect(() => {
    getData()
  }, [])

  const onFileClick = (id, fileName) => () => {
    getFile(id, fileName)
  }

  const renderFile = (file, i) => (
    <li key={i}>
      <span className={stylesNew.itemIcon}><FiFileText size={14} /></span>
      <button className={stylesNew.fileLink} onClick={onFileClick(file.id, file.link)}>
        {file.description}
      </button>
    </li>
  )

  const renderLink = (link, i) => (
    <li key={i}>
      <span className={stylesNew.itemIcon}><FiLink2 size={14} /></span>
      <a href={link.link} target="_blank" rel="noopener noreferrer">
        {link.description}
      </a>
    </li>
  )

  const renderText = (text, i) => (
    <li key={i}>
      <span className={stylesNew.itemIcon}><FiAlignLeft size={14} /></span>
      <span>{text.description}</span>
    </li>
  )

  const renderGroup = (title, items, renderItem) => !!items?.length && (
    <>
      <div className={stylesNew.groupTitle}>{title}</div>
      <ul className={stylesNew.resList}>{items.map(renderItem)}</ul>
    </>
  )

  const Section = ({ title, data }) => {
    const { files, text, url, methodical_files } = data || {}
    const noData = !files?.length && !text?.length && !url?.length && !methodical_files?.length
    return (
      <div className={stylesNew.res}>
        <h3>{title}</h3>
        <div className={stylesNew.resBody}>
          {noData
            ? <div className={stylesNew.emptySection}>Данные отсутствуют</div>
            : (
              <>
                {renderGroup('Файлы', files, renderFile)}
                {renderGroup('Методические материалы', methodical_files, renderFile)}
                {renderGroup('Материалы', text, renderText)}
                {renderGroup('Ссылки', url, renderLink)}
              </>
            )}
        </div>
      </div>
    )
  }

  return (
    <div className={stylesNew.moreInfoWrpaper}>
      <Section title="Основные образовательные ресурсы" data={data.main} />
      <Section title="Дополнительные образовательные ресурсы" data={data.additional} />
      <Section title="Методические указания для обучающихся" data={data.methodical} />
    </div>
  )
}
